module.exports = __webpack_public_path__ + "content/969db628401138a51bcb8101fa1b44d2.png";